import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { type RootState } from '@/store';
import Cookies from 'js-cookie';

const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_API_BASE_URL || '/api',
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.accessToken;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args: any, api: any, extraOptions: any) => {
  const result = await baseQuery(args, api, extraOptions);
  if (result.error && result.error.status === 401) {
    console.warn('Unauthorized! Logging out user...');
    Cookies.remove('authToken');
    setTimeout(() => {
      if (window.location.pathname === '/login') return;
      window.location.href = '/login';
    }, 2000);
  }
  return result;
};

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 0,
  tagTypes: [
    'User',
    'Auth',
    'FeatureFlags',
    'Common',
    'Account',
    'Upi',
    'Requests',
    'GetNotification',
    'Members',
    'GetBanner',
    'Casino',
    'Getsupport',
    'Event',
    'Market',
    'BetConfig',
    'Affiliates',
    'AffiliateSlabs',
    'AffiliateSlabHistory',
    'SystemSettings',
    'Wallet',
    'Provider',
    'BalanceSummary',
    'UserManagement',
    'GameAnalytics',
    'CasinoAnalytics',
    'BusinessAnalytics',
    'TopUsers',
    'TopCategories',
    'DeviceBreakdown',
    'BonusAnalytics',
    'LoginSummary',
    'LiveGames',
    'UserSummery',
    'accessMember',
    'Bonus',
    'BonusApplicants',
  ],
  endpoints: () => ({}),
});

// Export hooks for usage in functional components
export const {
  util: { getRunningQueriesThunk },
} = apiSlice;

// Export the api slice for use in store
export default apiSlice;
